import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromCartProductOrderNoteOptionsArray'
})
export class FromCartProductOrderNoteOptionsArrayPipe implements PipeTransform {
  transform(collection: any[]): string {
    const selectedOrderNoteOptions = [];

    collection.map((orderNoteOption) => {
      selectedOrderNoteOptions.push(orderNoteOption);
    });
    return selectedOrderNoteOptions.map((x) => '+ ' + x.text?.trim()).join(', ');
  }
}
